<template>
  <div class="checkout-total">
    <div class="checkout-total-row">
      <div class="checkout-total__title">
        {{ title }}
      </div>
      <div class="checkout-total__price">
        {{ price }}
      </div>
    </div>
    <div class="checkout-total-row">
      <div v-if="subtitle" class="checkout-total__subtitle">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4CheckoutTotal",
  props: {
    title: {
      type: String,
      default: "TOTAL"
    },
    subtitle: {
      type: String,
      default: ""
    },
    price: {
      type: String
    }
  }
};
</script>
